import { Flex, Card, Typography } from '@duxton-web/ui';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { colorBackgroundAlt } from '@duxton-web/design-tokens/themes/light';
import DataBox from 'omega-rtc/components/custom/DataBox';
import FlexColumn from 'omega-rtc/components/custom/FlexColumn';
import FlexRow from 'omega-rtc/components/custom/FlexRow';
import { OBJECTIVES_ICON_LABEL } from 'omega-rtc/constants/ucd';
import ProjectStatusTag from './ProjectStatusTag';

const ProjectDetailOverview = () => {
  const countries = useSelector((state) => state.countries.entities);
  const projectView = useSelector((state) => state.ucd.projectView);

  const project = useMemo(
    () => (projectView ? projectView.project : {}),
    [projectView],
  );

  if (!projectView) {
    return <div>Project not found</div>;
  }

  return (
    <Flex
      justify="space-around"
      vertical
      gap={24}
      style={{
        padding: '40px',
        background: colorBackgroundAlt,
      }}
      flex={1}
    >
      <Card
        style={{
          maxWidth: 844,
          flex: 1,
          padding: '24px 0px',
        }}
      >
        <FlexColumn>
          <Typography.Title level={4}>Project Details</Typography.Title>
          <FlexRow>
            <DataBox label="Audience" content={project.audience} />
            <DataBox
              label="Business Objective"
              content={OBJECTIVES_ICON_LABEL[project.objective].label}
            />
          </FlexRow>
          <FlexRow>
            <DataBox
              label="Country"
              content={
                countries.find(
                  (country) => country.countryID === project.countryID,
                ).name
              }
            />
            <DataBox label="Project Name" content={project.shortName} />
          </FlexRow>
          <FlexRow>
            <DataBox
              label="Project Code (Generated)"
              enableContentCopy
              content={project.code}
            />
          </FlexRow>
          <FlexRow>
            <DataBox
              label="Status"
              content={<ProjectStatusTag status={projectView.status} />}
            />
            <DataBox label="Creator" content={projectView.createdBy} />
          </FlexRow>
        </FlexColumn>
      </Card>
    </Flex>
  );
};

export default ProjectDetailOverview;
